module.exports = __webpack_public_path__ + "images/Datadog-b8ed12.png";